<template>
    <div class="body">
        <!-- <div class="shadow"></div> -->
        <!-- 海报区域 -->
        <div class="poster" ref="posterDom">
            <div class="content">
                <div style="background-color: #f5c143;height: 6vh;display: flex;align-items: center;border: 3px solid #fff;border-radius: 10px;">
                    <p  style="font-size: 22px;font-weight: bold;margin: 0;">&nbsp;2023年度学习成就</p>
                </div>
                <div style="height: 30vh; display: flex; background-color: #f0e4c7;border-radius: 10px 10px 0 0;">
                    <img :src="currentImage.imgUrl" alt="" style="width: 45%;transform: rotate(-10deg);margin-left: 2vh;margin-top: 3vh;">
                    <div style="width: 50%;text-align:center;margin-top: 6vh;">
                        <p style="font-size: 22px;font-weight: bold;margin: 0;">{{ReportData.examLab}}</p>
                        <p style="font-size: 22px;font-weight: bold;margin: 0;">{{ReportData.stuLab}}</p>
                        <p style="font-size: 22px;font-weight: bold;margin: 0;">{{ReportData.timeLab}}</p>
                    </div>
                </div>
                <!-- <div style=""> -->
                    <img class="bottom-image" src="../../assets//year23/train.png" alt="Bottom Image" style="width: 99.9%;height: 18vh; z-index: -11;position: relative;">
                    <!-- <div style="width: 70%;margin: 0 auto; display: flex;justify-content: space-between;">
                        <p style="font-size: 18px;margin: 0;color: gray;">出发地</p>
                        <p style="font-size: 18px;margin: 0;color: gray;">目的地</p>
                    </div>
                    <div style="width: 70%;margin: 0 auto; display: flex;justify-content: space-between;">
                        <p style="font-size: 25px;font-weight: bolder;margin: 0;">下一站</p>
                        <p style="font-size: 25px;font-weight: bolder;margin: 0;color: red;">有期许</p>
                    </div> -->
                <!-- </div> -->

                <div style="width:100%;height: 4vh; background-color: #f0e4c7;position: absolute;bottom: 0;">
                    <div style="display: flex;justify-content: space-between;">
                        <p style="font-size: 18px;margin: 0;color: rgb(54, 53, 53);">&nbsp;富士康大学</p>
                        <p style="font-size: 18px;margin: 0;color: rgb(54, 53, 53);;">富学宝典&nbsp;</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 按钮 -->
        <div class="btn">
            <button @click="drawer=true">学习计划</button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <button @click="savePoster">生成海报</button>
        </div>
        <!-- 学习计划 -->
        <transition name="fade">
            <div class="course-container" v-if="drawer">
                <label class="close-btn">
                    <i class="fa fa-close fa-lg" @click="drawer=false"></i>
                </label>
                <div class="course">
                    <!-- <div>
                        <p class="font1" style="padding-top: 11vh;">为君聊赋今日诗</p>
                        <p class="font1" style="padding-top: 1vh;">努力请从今日始</p>
                        <p class="font2" style="padding-top: 3vh;">你希望在富学宝典平台遇见哪些好课程？</p>
                        <p class="font2" style="padding-top: 1vh;">请写下你2024年的学习清单吧！</p>
                    </div> -->
                    <div style="display:flex;flex-wrap:wrap;justify-content:center;margin-top: 30vh;">
                        <div class="wrapper">
                            <textarea placeholder="请写下你的学习清单吧！" v-model="comment" class="text" name="text" rows="4" style="overflow: hidden; word-wrap: break-word; resize: none; height: 127px; "></textarea>
                        </div>
                        <button @click="submit">提交</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import html2canvas from 'html2canvas'
import saveAs from 'file-saver';
export default {
    props: ["ReportData"],
    data(){
        return{
            drawer:false,
            comment: '',
            studyList: '',
            imgItem:[
                {
                    id:1,
                    imgUrl:require('../../assets/year23/figure.png')
                },
                {
                    id:2,
                    imgUrl:require('../../assets/year23/figure2.png')
                },
            ],
            imgItem1:[
                {
                    id:1,
                    imgUrl:require('../../assets/year23/figure3.png')
                },
                {
                    id:2,
                    imgUrl:require('../../assets/year23/figure4.png')
                }
            ],
            currentImage: {}
        }
    },
    methods:{
        getRandomImage() {
            if(this.ReportData.gender=='男'){
                var randomIndex = Math.floor(Math.random() * this.imgItem.length);
                return this.imgItem[randomIndex];
            }else{
                var randomIndex = Math.floor(Math.random() * this.imgItem1.length);
                return this.imgItem1[randomIndex];
            }         
            
        },
        displayRandomImage() {
            this.currentImage = this.getRandomImage();
        },
        savePoster(){
            const posterElement = this.$refs.posterDom;
            html2canvas(posterElement, { useCORS: true }).then(canvas => {
                canvas.toBlob(blob => {
                    // 使用 FileSaver.js 的 saveAs 函数进行下载
                    saveAs(blob, 'poster.png');
                });
            // 将 Canvas 转换为图片并下载

            // const imageData = canvas.toDataURL('image/png');
            // const link = document.createElement('a');
            // link.href = imageData;
            // link.download = 'poster.png';
            // link.click();
            });
        },
        submit(){
            this.studyList = ''
            if(!this.comment) {
                this.$message({
                    message: '请说说您的学习计划',
                    type: 'warning',
                    center: true
                })
                return
            }else{
                this.drawer=false
            }
            const view = {
                comment: this.comment,
                studyList: this.studyList
            }
            this.$emit('submit',view)
        }
    },
    mounted(){
        this.displayRandomImage(); 
    }
}
</script>

<style scoped>
.body{
    height: 100vh;
    width: 100%;
    /* background: linear-gradient(to bottom, #add6dc, #c7cceb, #e7e6f4, #d5d0e0, #dbd8df); */
    background:url("../../assets/year23/bg3.jpg")  no-repeat;
    background-size: 100% 100%,cover;
}
/* .shadow{
    width: 70%;
    top: 10%;
    height: 66%;
    position:absolute; 
    left:50%;
    transform:translateX(-50%); 
    animation: faguang 2s infinite;
} */
@keyframes faguang {
  0%{
    letter-spacing: 0.25em;
    box-shadow: 0 0 25px #e5cc93;
  }
  50%{
    letter-spacing: 0.25em;
    box-shadow: 0 0 45px #f7d999;
  }
  100%{
    letter-spacing: 0.25em;
    box-shadow: 0 0 25px #fcd069;
  }
}
.poster{
    position: absolute;
    top: 10%;
    left:50%;
    transform:translateX(-50%); 
    height: 58vh;
    width: 70%;
}
/*  */
.btn{
    position: absolute;
    bottom:13%;
    display: flex;
    justify-content: center;
    width: 100%;
}
button {
    background: #FBCA1F;
    font-family: inherit;
    padding: 0.6em 1.3em;
    font-weight: 900;
    font-size: 15px;
    border: 2px solid black;
    border-radius: 5px;
    box-shadow: 1px 1px;
}

button:active {
    transform: translate(0.05em, 0.05em);
    box-shadow: 0.05em 0.05em;
}
.course-container{
    position: fixed;
    width: 100%;
    height: 100%; 
    background:url("../../assets/year23/bg4.jpg")  no-repeat;
    background-size: 100% 100%,cover;
    transition: opacity 0.5s;
}
.close-btn{
   margin-left: 95%;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.font1{
    width: 80%;
    margin: 0 auto;
    text-align:center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 80%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    font-size: 15px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.wrapper {
    width: 87%;
    height: auto;
    margin-bottom: 21px;
    display: flex;
    justify-content: center;
}
.text {
      width: 270px;
      overflow: hidden;
      background-color:rgba(227, 217, 216, 0.62);
      color: #953b5d;
      font-family: Courier, monospace;
      font-weight: normal;
      font-size: 21px;
      resize: none;
      line-height: 40px;
      padding-left: 27px;
      padding-right: 27px;
      padding-top: 25px;
      padding-bottom: 21px;
      background-repeat: repeat-y, repeat;
      -webkit-border-radius: 12px;
      border-radius: 12px;
      -webkit-box-shadow: 0px 2px 14px #000;
      box-shadow: 0px 2px 14px #000;
      border-top: 1px solid rgb(6, 142, 140);
      border-bottom: 1px solid rgb(6, 142, 140);
    }
.text:focus {
    outline: none; 
}
</style>